import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';

import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from '@azure/msal-react';

import GotoAusmed from './ui-components/GotoAusmed';
import LoginButton from './ui-components/LoginButton';
import Card from 'react-bootstrap/Card';


import { PublicClientApplication, EventType } from '@azure/msal-browser';
import Navbar from 'react-bootstrap/Navbar';
import { useLocation } from 'react-router-dom';
import brandImg from './images/ausmedBrand.svg';
import { PathToDict } from './orgDict';
import { isFirefox, isIE, isEdge } from 'react-device-detect';

// import myMock from './mockData';

// import Footer from './Footer';

// Account selection logic is app dependent. Adjust as needed for different use cases.
const initAcct = (pca) => {
  const accounts = pca.getAllAccounts();
  if (accounts.length > 0) {
    pca.setActiveAccount(accounts[0]);
  }

  pca.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      const account = event.payload.account;
      pca.setActiveAccount(account);
    }
  });
};

function App() {
  const location = useLocation();
  /**
   * React.useEffect remember to have empty array as second param to make it only be called once
   * As statements outside React.useEffect can be called many times, try to only put [state, setState] outside,
   *  and all other consts or calculations inside React.useEffect
   * [state, setState]: state cannot be accessed within React.useEffect, it's used in return (<></>)
   * All the value used in return should be [state] which setState is called in React.useEffect with empty
   *  array that only execute once so that the sub component will not be called many times
   */
  const [instance, setInstance] = React.useState(null); // here 'instance' and below 'customConfig' can only be used in return
  const [oldInstance, setOldInstance] = React.useState(null); // here 'instance' and below 'customConfig' can only be used in return
  const [customConfig, setCustomConfig] = React.useState(null);
  const [oldDictState, setOldDictState] = React.useState(null);
  const [orgCodeState, setOrgCodeState] = React.useState(undefined);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    
    const currentPath = location.pathname;
    const pathArr = location.pathname.split('/');
    

    // TO Remove Old Code Start 
    const oldDict = currentPath ? PathToDict[pathArr[1]] : undefined;
    if (oldDict?.config?.auth?.clientId) { // old config exist, no need to fetch org
      const oldApplication = new PublicClientApplication(oldDict.config);
      // console.log('🥮 old instance');
      initAcct(oldApplication);
      setOldInstance(oldApplication);
      setOldDictState(oldDict);
      setLoaded(true);
    }
    // TO Remove Old Code Finish


    /**
     * Attention!! orgCode is in lowercase, and the redirect uri orgs put in their setting should also have lowercase orgCode
     */
    const orgCode = pathArr[1]? pathArr[1].replace(/[^a-zA-Z0-9]/g, '').toLowerCase(): undefined;

    // TO Remove oldDict in if statement
    if (!oldDict && orgCode) {
      // console.log('🍢 set org code');
      setOrgCodeState(orgCode);


      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      };

      fetch(
        `${process.env.REACT_APP_accountServiceEndpoint}/orgs/byCode/${orgCode}/public`,
        requestOptions
      )
      .then((response) => response.json())
      .then((org) => {
        setCustomConfig(org?.customConfig);
        const azureConfig = org?.customConfig?.azureConfig;

        if (azureConfig?.clientID) {
          const tenantID = azureConfig.tenantID || 'common';
          const application = new PublicClientApplication({
            auth: {
              clientId: azureConfig.clientID,
              authority: `https://login.microsoftonline.com/${tenantID}/`,
              redirectUri: `/${orgCode}/redirect`, // Note: need to specify redirect=true to distinguish original landing and redirect back, used in LoginButton to stop 'skiplanding' from functioning
              postLogoutRedirectUri: `/`,
              navigateToLoginRequestUrl: false,
            },
            cache: {
              cacheLocation : 'localStorage',
              storeAuthStateInCookie: isIE || isEdge || isFirefox,
            },
          });
          initAcct(application);
          setInstance(application);
          // console.log('🍢 finish init');
          setLoaded(true);
        }  
      })
      .catch((error) => {
        console.log('Error fetching data:', error);
      });
    }
  }


  , []);// empty dependency array means this effect will only run once (like componentDidMount in classes)

  return (
    <>
      {
        loaded && instance &&
        (
          <MsalProvider instance={instance}>
            <Pages orgCode={orgCodeState} customConfig={customConfig} />
          </MsalProvider>
         ) 
      }
      {
        loaded && oldInstance && 
        (
          <MsalProvider instance={oldInstance}>
            <OldPages dict={oldDictState} />
          </MsalProvider>
        )
      }
    </>
  );

}

// https://learn.microsoft.com/en-us/azure/active-directory-b2c/enable-authentication-react-spa-app
function OldPages({ dict }) {
  const [sublogo, setSubLogo] = React.useState('');
  const [logo, setLogo] = React.useState('');
  const [load, setLoad] = React.useState(false);
  const orgCode = dict.orgCode;

  // console.log('🌯 orgCode: ', orgCode);

  React.useEffect(() => {
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };

    // console.log('🌽', orgCode);

    /**
     * TODO: config info will be added to this api; after that, try to use it also in ausmed-cpd -> my-org-sso-redirect.ts
     */
    fetch(
      `${process.env.REACT_APP_accountServiceEndpoint}/orgs/byCode/${orgCode}/public`, //${orgCode}
      requestOptions
    )
      .then((response) => response.json())
      .then((org) => {
        const config = org?.customConfig;
        setSubLogo(config && config.lmsLogoLink);
        setLogo(config && config.logoLink);
        setLoad(true);
      })
      .catch((error) => {
        setLoad(true);
        console.log('Error fetching data:');
      });
  }, []); // empty dependency array means this effect will only run once (like componentDidMount in classes)

  return (
    <>
      <style type='text/css'>
        {`
              .nav {
                background-color: white;
                border-bottom: 1px solid #E5E5E8;
                height: 72px;
              }

              .site {
                padding: 0px;
                height:100vh;   
              }


              .company {
                color: #7F7D87;
                text-decoration: none;
                cursor: pointer
              }

              .company:hover {
                text-decoration: underline;
                color: #7F7D87;
              }

              .main-logo{
                max-height: 140px;
                max-width: 370px;
              }
  
      `}
      </style>

      <div className='site'>
        <Navbar className='nav'>
          <Navbar.Brand href={process.env.REACT_APP_host}>
            <img src={brandImg} width='112' height='70' className='d-inline-block align-top' alt='Ausmed logo' />
          </Navbar.Brand>
        </Navbar>
        {load && (
          <div className='row justify-content-center'>
            <div className='col-12 col-sm-8 col-md-6 col-lg-5'>
              <div className='d-flex flex-column justify-content-center'>
                <div className='text-center mt-5 mb-2'>
                  {logo && <img src={logo} alt='LMS Logo' className='main-logo' />}
                </div>

                <Card style={{ maxWidth: '600px', minWidth: '375px' }} className='mx-auto mb-2'>
                  {sublogo && (
                    <Card.Img variant='top' src={sublogo} style={{ width: '65%' }} className='mx-auto mt-3' />
                  )}

                  {!sublogo && (
                    <div>
                      <div style={{ height: '60px' }}></div>
                    </div>
                  )}
                  <Card.Body style={{ height: '15rem', width: '90%' }} className='mx-auto'>
                    <AuthenticatedTemplate>
                      <GotoAusmed orgCode={orgCode} redirectToMyOrg={dict.redirectToMyOrg} />
                    </AuthenticatedTemplate>

                    <UnauthenticatedTemplate>
                      {/* <Redirect /> */}
                      <LoginButton skipLanding={dict.skipSSOLandingPage} />
                    </UnauthenticatedTemplate>
                  </Card.Body>

                  <div className='pb-4'>
                    <div style={{ height: '6rem' }}></div>
                    <div className='d-flex flex-row justify-content-around mb-4'>
                      <a
                        href={process.env.REACT_APP_host + '/privacy-policy'}
                        className='company'
                        target='_blank'
                        rel='noreferrer'
                      >
                        Privacy
                      </a>
                      <a
                        href={process.env.REACT_APP_host + '/terms-and-conditions'}
                        className='company'
                        target='_blank'
                        rel='noreferrer'
                      >
                        Terms
                      </a>
                      <span className='text-muted'>Ausmed 2022©</span>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* <Footer /> */}
    </>
  );
}



function Pages({ orgCode,  customConfig}) {

  const sublogo = customConfig.lmsLogoLink;
  const logo = customConfig.logoLink


  return (
    <>
      <style type='text/css'>
        {`
              .nav {
                background-color: white;
                border-bottom: 1px solid #E5E5E8;
                height: 72px;
              }

              .site {
                padding: 0px;
                height:100vh;   
              }

              .company {
                color: #7F7D87;
                text-decoration: none;
                cursor: pointer
              }

              .company:hover {
                text-decoration: underline;
                color: #7F7D87;
              }

              .main-logo{
                max-height: 140px;
                max-width: 370px;
              }
  
      `}
      </style>

      <div className='site'>
        <Navbar className='nav'>
          <Navbar.Brand href={process.env.REACT_APP_host}>
            <img src={brandImg} width='112' height='70' className='d-inline-block align-top' alt='Ausmed logo' />
          </Navbar.Brand>
        </Navbar>
        
        <div className='row justify-content-center'>
          <div className='col-12 col-sm-8 col-md-6 col-lg-5'>
            <div className='d-flex flex-column justify-content-center'>
              <div className='text-center mt-5 mb-2'>
                {logo && <img src={logo} alt='LMS Logo' className='main-logo' />}
              </div>

              <Card style={{ maxWidth: '600px', minWidth: '375px' }} className='mx-auto mb-2'>
                {sublogo && (
                  <Card.Img variant='top' src={sublogo} style={{ width: '65%' }} className='mx-auto mt-3' />
                )}

                {!sublogo && (
                  <div>
                    <div style={{ height: '60px' }}></div>
                  </div>
                )}
                <Card.Body style={{ height: '15rem', width: '90%' }} className='mx-auto'>
                  <AuthenticatedTemplate>
                    <GotoAusmed orgCode={orgCode} redirectToMyOrg={customConfig.redirectToMyOrg} />
                  </AuthenticatedTemplate>

                  <UnauthenticatedTemplate>
                    {/* <Redirect /> */}
                    <LoginButton skipLanding={customConfig.skipSSOLandingPage} />
                  </UnauthenticatedTemplate>
                </Card.Body>

                <div className='pb-4'>
                  <div style={{ height: '6rem' }}></div>
                  <div className='d-flex flex-row justify-content-around mb-4'>
                    <a
                      href={process.env.REACT_APP_host + '/privacy-policy'}
                      className='company'
                      target='_blank'
                      rel='noreferrer'
                    >
                      Privacy
                    </a>
                    <a
                      href={process.env.REACT_APP_host + '/terms-and-conditions'}
                      className='company'
                      target='_blank'
                      rel='noreferrer'
                    >
                      Terms
                    </a>
                    <span className='text-muted'>Ausmed 2022©</span>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </div> 
      </div>
      {/* <Footer /> */}
    </>
  );
}

export default App;
